var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',{staticClass:"pl-3 pr-3 see-all-link",attrs:{"size":"sm","color":"primary"},on:{"click":_vm.toPage}},[_vm._v("See all")])}
var staticRenderFns = []

export { render, staticRenderFns }